<template>
  <div>
    <c-search-box ref="searchbox" @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-12"></div>
        <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
          <c-multi-select
            codeGroupCd="REGULATION_BILL_CD"
            itemText="codeName"
            itemValue="code"
            label="관련 법규"
            name="searchLaw"
            @datachange="billCdChange"
            v-model="searchLaw">
          </c-multi-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
          <c-multi-select
            type="search"
            :comboItems="regulatedItems"
            itemText="regulatedItemName"
            itemValue="regulatedItemCd"
            label="규제 법규"
            name="regulatedItemCd"
            v-model="searchParam.regulatedItemCd">
          </c-multi-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          title="화학자재 목록"
          tableId="chemMaterialPop"
          :columns="grid.columns"
          :data="grid.data"
          :gridHeight="grid.height"
          :columnSetting="false"
          :selection="popupParam.type"
          rowKey="mdmChemMaterialId"
          @linkClick="linkClick"
          @rowDblclick="rowDblclick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="검색" icon="search" @btnClicked="getList" />
              <c-btn v-if="editable" label="선택" icon="check" @btnClicked="select" />
            </q-btn-group>
          </template>
        </c-table>
        <c-dialog :param="popupOptions"></c-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'chem-pop',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          type: 'single',
          plantCd: '',
        }
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      searchLawItems: [],
      searchLaw: [],
      searchParam: {
        plantCd: null,
        useFlag: 'Y',
        mdmChemMaterialId: '',
        materialName: '',
        regulatedItemCd: [],
        searchItems: [],
        headerType: 'color'
      },
      regulatedItems: [],
      originalData: [],
      filterData: [],
      popupOptions: {
        isFull: false,
        width: '90%',
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      grid: {
        columns: [
          {
            id: 'original',
            name: 'plantName',
            field: 'plantName',
            label: '사업장명',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            id: 'original',
            name: 'mdmChemMaterialId',
            field: 'mdmChemMaterialId',
            label: '화학자재 번호',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            id: 'original',
            name: 'materialName',
            field: 'materialName',
            label: '화학자재명',
            align: 'left',
            type: 'link',
            style: 'width:250px',
            sortable: true,
          },
          {
            id: 'original',
            name: 'materialNameEn',
            field: 'materialNameEn',
            label: '화학자재명(ENG)',
            align: 'left',
            style: 'width:200px',
            sortable: true,
          },
          {
            id: 'original',
            name: 'propertiesStateName',
            field: 'propertiesStateName',
            label: '성상',
            align: 'center',
            style: 'width:60px',
            sortable: true,
          },
          {
            id: 'original',
            name: 'existRegulation',
            field: 'existRegulation',
            label: '규제법규포함',
            align: 'center',
            type: 'color',
            style: 'width:70px',
            sortable: true,
          }
        ],
        height: '500px',
        data: [],
      },
      editable: true,
      headerUrl: '',
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    this.headerUrl = selectConfig.mdm.mam.chem.header.url;
    this.getHeader();
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  watch: {
    contentHeight() {
      let height = (this.contentHeight - this.$refs['searchbox'].$el.offsetHeight - 50);
      if (height < 400) {
        height = 500;
      }
      this.grid.height = height + 'px'
    }
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = selectConfig.mdm.mam.chem.listreg.url;
      this.regsUrl = selectConfig.mdm.mam.chem.regs.url;
      this.getList();
    },
    getHeader() {
      this.$http.url = this.headerUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.$_.forEach(_result.data, _item => {
          this.grid.columns.push(_item);
        })
        this.originalData = this.grid.columns;
      },);
    },
    billCdChange(newValue) {
      this.searchLawItems = [];
      this.searchParam.regulatedItemCd = [];
      if (!newValue || newValue.length === 0) {
        this.grid.columns = this.originalData;
      } else {
        this.$_.forEach(newValue, _item => {
          this.searchLawItems.push(_item.value);
        })
        var _searchLawItems = this.searchLawItems;
        this.filterData = this.originalData.filter(function (object) {
          return _searchLawItems.indexOf(object['id']) > -1 || object['id'] === 'original';
        });
        this.grid.columns = this.filterData;
      }
      this.searchParam.searchItems = [];
      this.$_.forEach(newValue, _item => {
        this.searchParam.searchItems.push(_item.value)
      })
      this.$http.url = this.regsUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.regulatedItems = _result.data;
      },);
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.popupOptions.title = '화학자재 상세';
      this.popupOptions.param = {
        mdmChemMaterialId: row ? row.mdmChemMaterialId : '',
        plantCd: row ? row.plantCd : '',
      };
      this.popupOptions.target = () => import(`${'./chemDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    select() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '화학자재를 선택하세요.', // 화학자재를 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === 'single') {
        this.$emit('closePopup', [row]);
      }
    },
  }
};
</script>
